import _ from "underscore";

import {ItemGroup} from "./itemGroup";
import {GroupRepository} from './groupRepository';

import {ExpressionParser, Expression} from '../tags/expression';
import reactive = require('../reactive');
import {XmlTagInfo} from '../xmlTagProvider';
import {Form} from '../form/form';
import {Questionary} from '../questionary';
import {SyntheticItem} from "../items/synthetic";

export class SyntheticGroup extends ItemGroup<SyntheticItem> {

	private expression!: Expression<any>; // is set in init
	private questionary: Questionary;
	private unparsedExpression?: XmlTagInfo;
	private respectUndefined: boolean;

	constructor(config: XmlTagInfo, form: Form){
		super(config, form);
		this.unparsedExpression = config.children[0];
		this.respectUndefined = config.attributes['respectUndefined'] === 'yes';
		this.questionary = form.questionary;
	}

	init() {
		const variables = this.questionary.state.variables;

		if (this.unparsedExpression) {
            // unparsedExpression is set ini constructor
            this.expression = ExpressionParser.parseSynthetic(this.unparsedExpression, this.form.timeVariableName, this.variableNames, this.respectUndefined);

            // and wipe unparsedExpression
            this.unparsedExpression = undefined;
        }

		if (this.expression instanceof Expression) {
			this.expression.init(this.questionary.state);

			// TODO: handle true array result -> multiple variables ?
			const variableName = this.variableNames[0];
			const resultVariable = variables[variableName];
			resultVariable.computed = true;

			reactive.bind(() => {

			    const result = this.expression.evaluate(this.questionary.state);
			    resultVariable(result);

				this.questionary.trigger(Questionary.Events.NOTIFY_SYNTHETIC_VARIABLE_VALUE_UPDATE, `${variableName}: ${this.expression.describe()} -> ${result}`);
			}, _.pick(variables, this.expression.dependencies));
		} else {
			// console.log(`Synthetic group ${this.form.id}.${this.id} has unparsed expression`);
		}
	}
}

// @ts-ignore
GroupRepository.register('syntheticGroup', SyntheticGroup);
